import React from 'react';
import {Stack} from '@mui/material';
import {Headline, Icon} from '@lightricks/react-design-system';
import translate from '@/utils/translate';
import FeatureDetails from '../type';

function FeatureAssetPageTitle({
  featureDetails,
}: {
  featureDetails: FeatureDetails;
}) {
  return (
    <Stack direction="row" alignItems="center" spacing="8px">
      <Headline size="lg">
        {translate(
          featureDetails.isMultipleSelect
            ? 'featureAssetPageTitleMultiple'
            : 'featureAssetPageTitleSingle',
          {
            featureName: featureDetails.name,
          }
        )}
      </Headline>
      {featureDetails.icon && (
        <Icon name={featureDetails.icon} size="large" appearance="primary" />
      )}
    </Stack>
  );
}

export default FeatureAssetPageTitle;
